function u(r) {
  return (t) => {
    r.forEach((o) => {
      typeof o == "function" ? o(t) : o != null && (o.current = t);
    });
  };
}
export {
  u as o
};
